import React from 'react';
import PropTypes from 'prop-types';
import CacDynamicTabs from './enhancedFeatures/CacDynamicTabs';
import CorrView from './Correspondence/CorrView';
import ClusterView from './Cluster/ClusterView';
import { useDispatch } from '../common/react-redux-hooks';
import * as cacActions from '../../actions/cacActions';

function CacViewComponent(props) {
  const { project } = props;
  const dispatch = useDispatch();

  const handleTabSelect = tabIndex => {
    dispatch(cacActions.handleTabSelect(tabIndex));
  };

  return (
    <div className="CacViewComponent">
      <CacDynamicTabs
        data-test="CacDynamicTabsComp"
        styles={{ backgroundColor: 'rgba(70, 84, 106, 0)', textAlign: 'center' }}
        selectedIndex={project.selectedTabIndex}
        handleSelect={handleTabSelect}
        tabs={[
          {
            title: 'Correspondence',
            content: (
              <CorrView
                project={project}
                redrawChart={false}
              />
            ),
          },
          {
            title: 'Cluster',
            content: (
              <ClusterView
                project={project}
              />
            ),
          },
        ]}
      />
    </div>
  );
}

CacViewComponent.propTypes = {
  project: PropTypes.shape({
    selectedTabIndex: PropTypes.number,
  }),
};

export default CacViewComponent;
